import MsDyn365, { ICoreContext } from '@msdyn365-commerce/core';

export const getPublicAssetPath = (context: ICoreContext, publicFolderAssetPath: string) => {
    const staticCdnUrl = context.request.url.staticCdnUrl;
    const submissionId = MsDyn365.getEnvironmentVariable('SUBMISSIONID');
    return `${staticCdnUrl}${submissionId}/${publicFolderAssetPath}`;
};
